module.exports = __webpack_public_path__ + "img/icon-remove.9b4d8116.svg";